<template>
  <page-component style="position: relative" :loading="loading">
    <template #content>
      <v-icon
        class="mt-0 d-block mr-auto mb-4"
        @click="$store.state.search_result_visibility = false"
        >mdi-close-circle</v-icon
      >
      <v-sheet
        class="mx-auto mb-7 mb-5 selected-slider"
        style="
          height: 50px;
          overflow: hidden;
          border-radius: 5px;
          max-width: 100% !important;
          margin-top: 30px;
        "
        v-if="$store.state.elements.length"
      >
        <v-slide-group multiple show-arrows>
          <v-slide-item v-for="(person, i) in $store.state.elements" :key="i">
            <v-chip
              outlined
              color="#F6F7FA"
              class="my-0 py-0 mr-3"
              style="
                clip-path: unset !important;
                border-radius: 5px !important;
                height: 36px;
                flex-shrink: 0;
                padding-left: 30px !important;
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14.07"
                height="13.135"
                viewBox="0 0 20.07 19.135"
                style="margin-bottom: -2px; margin-left: 8px"
              >
                <path
                  id="Icon_feather-star-mute"
                  data-name="Icon feather-star-mute"
                  d="M12.535,3l2.946,5.969,6.589.963L17.3,14.575l1.125,6.56-5.893-3.1-5.893,3.1,1.125-6.56L3,9.932l6.589-.963Z"
                  transform="translate(-2.5 -2.5)"
                  fill="white"
                  stroke="#acacac"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                />
              </svg>
              {{ person.customer?.name }}
              <v-icon
                style="
                  font-size: 13px;
                  position: absolute;
                  left: 3px;
                  top: 4px;
                  cursor: pointer;
                "
                @click="deleteSelectedPerson(i)"
                >mdi-close</v-icon
              >
            </v-chip>
          </v-slide-item>
        </v-slide-group>
      </v-sheet>
      <v-row class="mt-0 mx-0"  v-if="currentRole == 0 && search_result.length">
        <v-col
          cols="12"
          lg="3"
          md="4"
          sm="6"
          xs="12"
          v-for="person in search_result"
          :key="person.id"
          class="px-2 py-1"
        >
          <v-card class="pa-3 position-relative" style="height: 100%">
            <span
              class="right-color"
              :style="`position: absolute;
                  width: 6px;
                  height: 100%;
                  top: 0;
                  right: -6px;${
                    person.status == `طلب تم فتحه`
                      ? `background-color:#40BE72`
                      : person.status == `طلب جديد`
                      ? `background-color:#3B5DE7`
                      : person.status == `مؤرشف لدى استشاري المبيعات`
                      ? `background-color:#017E84`
                      : person.status == `طلب مرفوض`
                      ? `background-color: indianred`
                      : person.status == `في انتظار موافقة مدير المبيعات`
                      ? `background-color: #FF715B`
                      : `background-color:black`
                  }`"
            ></span>
            <div class="card-head d-flex justify-space-between align-center">
              <v-card-title
                class="pa-0"
                style="font-size: 15px; font-weight: bold"
                >{{ person.customer?.name }}</v-card-title
              >
              <div class="icons">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="select_element(person)"
                      width="30"
                      height="30"
                      color="transparent"
                      depressed
                      fab
                    >
                      <v-icon
                        size="30"
                        :color="
                          in_selected_elements(person) ? 'primary' : '#999898'
                        "
                        >{{
                          in_selected_elements(person)
                            ? "mdi-square-circle"
                            : "mdi-crop-square"
                        }}</v-icon
                      >
                    </v-btn>
                    <v-btn
                      width="30"
                      height="30"
                      color="transparent"
                      depressed
                      fab
                      light
                      v-bind="attrs"
                      v-on="on"
                      style="margin-left: -10px"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="5.153"
                        height="27.986"
                        viewBox="0 0 4.153 18.986"
                      >
                        <path
                          id="menu"
                          d="M16.077,43.153a2.166,2.166,0,0,1-1.483-.623A2.066,2.066,0,0,1,14,41.077a2.341,2.341,0,0,1,.593-1.483A2.085,2.085,0,0,1,16.077,39a2.2,2.2,0,0,1,1.454.593,2.092,2.092,0,0,1-1.454,3.56Zm8.87-.623a2.1,2.1,0,0,0,.623-1.454,2.223,2.223,0,0,0-.623-1.483A2.066,2.066,0,0,0,23.493,39a2.278,2.278,0,0,0-1.483.593,2.085,2.085,0,0,0-.593,1.483,2.2,2.2,0,0,0,.593,1.454,2.042,2.042,0,0,0,2.937,0Zm7.417,0a2.1,2.1,0,0,0,.623-1.454,2.223,2.223,0,0,0-.623-1.483A2.066,2.066,0,0,0,30.91,39a2.278,2.278,0,0,0-1.483.593,2.085,2.085,0,0,0-.593,1.483,2.2,2.2,0,0,0,.593,1.454,2.042,2.042,0,0,0,2.937,0Z"
                          transform="translate(-39 32.986) rotate(-90)"
                          fill="#3b5de7"
                        />
                      </svg>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="to_request_details(person)">
                      <v-list-item-icon class="ml-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18.528"
                          height="15.111"
                          viewBox="0 0 13.528 10.111"
                        >
                          <g
                            id="Icon_feather-eye-dark"
                            data-name="Icon feather-eye-dark"
                            transform="translate(-1 -5.5)"
                          >
                            <path
                              id="Path_4040"
                              data-name="Path 4040"
                              d="M1.5,10.556S3.778,6,7.764,6s6.264,4.556,6.264,4.556-2.278,4.556-6.264,4.556S1.5,10.556,1.5,10.556Z"
                              fill="none"
                              :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1"
                            />
                            <path
                              id="Path_4041"
                              data-name="Path 4041"
                              d="M16.917,15.208A1.708,1.708,0,1,1,15.208,13.5,1.708,1.708,0,0,1,16.917,15.208Z"
                              transform="translate(-7.444 -4.653)"
                              fill="none"
                              :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1"
                            />
                          </g>
                        </svg>
                      </v-list-item-icon>
                      <v-list-item-title>فتح</v-list-item-title>
                    </v-list-item>
                    <router-link
                      style="text-decoration: none"
                      target="_blank"
                      :to="{ name: 'request_details', params: { id: person.id } }"
                    >
                      <v-list-item>
                        <v-list-item-icon class="ml-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18.528"
                            height="15.111"
                            viewBox="0 0 13.528 10.111"
                          >
                            <g
                              id="Icon_feather-eye-dark"
                              data-name="Icon feather-eye-dark"
                              transform="translate(-1 -5.5)"
                            >
                              <path
                                id="Path_4040"
                                data-name="Path 4040"
                                d="M1.5,10.556S3.778,6,7.764,6s6.264,4.556,6.264,4.556-2.278,4.556-6.264,4.556S1.5,10.556,1.5,10.556Z"
                                fill="none"
                                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                              />
                              <path
                                id="Path_4041"
                                data-name="Path 4041"
                                d="M16.917,15.208A1.708,1.708,0,1,1,15.208,13.5,1.708,1.708,0,0,1,16.917,15.208Z"
                                transform="translate(-7.444 -4.653)"
                                fill="none"
                                :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1"
                              />
                            </g>
                          </svg>
                        </v-list-item-icon>
                        <v-list-item-title> فتح في تاب جديد</v-list-item-title>
                      </v-list-item>
                    </router-link>
                    <v-list-item @click="to_tickets_page(person)">
                      <v-list-item-icon class="ml-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18.014"
                          viewBox="0 0 18 18.014"
                        >
                          <g id="ticket" transform="translate(-72.188 -72)">
                            <path
                              id="Path_2758"
                              data-name="Path 2758"
                              d="M89.062,76.532a.489.489,0,0,0-.622-.059,1.956,1.956,0,0,1-2.711-2.721.5.5,0,0,0-.059-.617l-.563-.563A1.96,1.96,0,0,0,83.723,72h0a1.959,1.959,0,0,0-1.385.573l-9.582,9.611a1.96,1.96,0,0,0,0,2.765l.377.372a.494.494,0,0,0,.656.034,1.941,1.941,0,0,1,2.736,2.731.489.489,0,0,0,.029.661l.695.695a1.961,1.961,0,0,0,2.77,0h0l9.592-9.592a1.961,1.961,0,0,0,0-2.77ZM79.323,88.747a.981.981,0,0,1-1.385,0l-.4-.4a2.916,2.916,0,0,0-4-4l-.083-.083a.981.981,0,0,1,0-1.385l6.523-6.548,5.882,5.882Zm9.592-9.592-2.369,2.369-5.882-5.887,2.359-2.369a.962.962,0,0,1,.69-.289h0a.978.978,0,0,1,.69.284l.3.3a2.939,2.939,0,0,0,3.93,3.93l.279.279a.976.976,0,0,1,0,1.385Z"
                              transform="translate(0)"
                              fill="#383c40"
                            />
                            <path
                              id="Path_2759"
                              data-name="Path 2759"
                              d="M169.609,216.41l-2.373-2.374a.981.981,0,0,0-1.385,0h0l-2.315,2.315a.981.981,0,0,0,0,1.385l2.374,2.373a.981.981,0,0,0,1.385,0l2.315-2.315a.969.969,0,0,0,.024-1.375C169.629,216.41,169.624,216.4,169.609,216.41Zm-3,3-2.378-2.373,2.315-2.315h0l2.373,2.373Z"
                              transform="translate(-86.606 -134.813)"
                              fill="#383c40"
                            />
                          </g>
                        </svg>
                      </v-list-item-icon>
                      <v-list-item-title>التذاكر</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="to_chat_page(person)">
                      <v-list-item-icon class="ml-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17.599"
                          height="18.22"
                          viewBox="0 0 17.599 18.22"
                        >
                          <g id="chat" transform="translate(-2.1 -1.2)">
                            <path
                              id="Path_2760"
                              data-name="Path 2760"
                              d="M11.565,37.775a3.256,3.256,0,0,0-2.366-1.6c-.769-.207-.739-.5-.71-.739l.059-.118a.029.029,0,0,1,.03-.03c.03-.059.089-.118.118-.177A1.807,1.807,0,0,0,8.9,34.7c.03-.059.03-.118.059-.177,0-.03.03-.059.03-.089l.089-.089.207-.237.03-.03a1.289,1.289,0,0,0,.177-.5v-.089c0-.089.03-.148.03-.237v-.177a.782.782,0,0,0-.3-.621.267.267,0,0,1,.03-.148,2.252,2.252,0,0,0,.089-.621,1.673,1.673,0,0,0-.237-.946,1.881,1.881,0,0,0-.8-.71c-.059-.03-.148-.059-.207-.089a3.218,3.218,0,0,0-1.183-.207H6.655a2.493,2.493,0,0,0-.887.177c-.03.03-.089.03-.089.059a1.023,1.023,0,0,0-.325.3l-.03.059c-.03.059-.03.059-.059.059a.394.394,0,0,1-.148.089.64.64,0,0,0-.355.325,1.889,1.889,0,0,0-.177.651,5.013,5.013,0,0,0,.03.651c0,.089.03.177.03.266v.03a.618.618,0,0,0-.325.621v.207c0,.089.03.177.03.237v.089a1.267,1.267,0,0,0,.148.473c.059.089.089.148.148.177a.784.784,0,0,0,.177.148,2.8,2.8,0,0,0,.325.739v.03l.03.03.059.089.03.03c.03.03.03.03.03.059l.03.03v.03c.03.207.089.5-.71.739a3.529,3.529,0,0,0-2.366,1.6,1.955,1.955,0,0,0-.148.769v.562a.392.392,0,0,0,.385.385h0a.392.392,0,0,0,.385-.385v-.532a1.854,1.854,0,0,1,.059-.473c.266-.621,1.183-.976,1.893-1.183q1.464-.4,1.242-1.6a.657.657,0,0,0-.148-.325l-.03-.03c0-.03-.03-.03-.03-.059L5.738,34.7a3.205,3.205,0,0,1-.237-.562.6.6,0,0,0-.237-.355l-.059-.03c-.03,0-.03-.03-.059-.059a.1.1,0,0,1-.03-.059.42.42,0,0,1-.059-.177l.059-.118c0-.059-.03-.118-.03-.177v-.089h.059l.089-.03a.462.462,0,0,0,.207-.385,1.746,1.746,0,0,0-.059-.414c0-.059-.03-.118-.03-.177a1.766,1.766,0,0,1,0-.562.636.636,0,0,1,.059-.3A1.221,1.221,0,0,0,5.738,31a.68.68,0,0,0,.207-.237l.03-.059a.231.231,0,0,1,.118-.118,2.1,2.1,0,0,1,.621-.118h.207a2.3,2.3,0,0,1,.917.177c.059.03.089.03.148.059a.821.821,0,0,1,.444.385,1.013,1.013,0,0,1,.118.532,2.589,2.589,0,0,1-.059.473,1.006,1.006,0,0,0-.03.3v.089a.505.505,0,0,0,.03.355.529.529,0,0,0,.3.266v.089a.375.375,0,0,1-.03.177.178.178,0,0,1-.03.118.25.25,0,0,1-.059.177l-.03.03-.059.03-.207.207a.879.879,0,0,0-.177.385c0,.03,0,.059-.03.059a2.748,2.748,0,0,1-.148.3c-.03.03-.03.059-.059.089l-.207.3a.557.557,0,0,0-.059.237q-.222,1.2,1.242,1.6a2.793,2.793,0,0,1,1.893,1.183,1.3,1.3,0,0,1,.059.473v.532a.373.373,0,0,0,.385.385h0a.392.392,0,0,0,.385-.385v-.562A1.135,1.135,0,0,0,11.565,37.775Zm-.237,1.568Zm8.37-.8a1.865,1.865,0,0,0-.148-.769,3.256,3.256,0,0,0-2.4-1.6c-.769-.207-.739-.5-.71-.739l.059-.148.03-.03c.03-.059.089-.118.118-.177a2.686,2.686,0,0,0,.207-.414,1.233,1.233,0,0,0,.059-.177V34.4c.03-.03.059-.059.089-.059l.03-.03.03-.03.177-.207.03-.03a1.289,1.289,0,0,0,.177-.5v-.089c0-.089.03-.148.03-.237v-.177a.782.782,0,0,0-.3-.621.267.267,0,0,1,.03-.148,2.607,2.607,0,0,0,.089-.621,1.673,1.673,0,0,0-.237-.946,1.881,1.881,0,0,0-.8-.71v-.03a.5.5,0,0,0-.148-.059,3.113,3.113,0,0,0-1.183-.207H14.67a2.06,2.06,0,0,0-.887.177c-.059.03-.089.059-.118.059a1.55,1.55,0,0,0-.325.3l-.03.089-.03.03a.029.029,0,0,1-.03.03.27.27,0,0,1-.148.089.64.64,0,0,0-.355.325,1.889,1.889,0,0,0-.177.651V32.1c0,.089.03.177.03.266v.03a.618.618,0,0,0-.325.621v.177a.912.912,0,0,0,.03.266v.089a2.216,2.216,0,0,0,.148.473c.059.059.089.148.148.177a.784.784,0,0,0,.177.148,2.43,2.43,0,0,0,.325.739v.03l.089.118.03.03c.03.03.03.03.03.059l.03.059c.03.207.089.5-.71.739a6.474,6.474,0,0,0-1.213.473l-.03.03a3.545,3.545,0,0,1,.5.621,5.782,5.782,0,0,1,.946-.355q1.464-.4,1.242-1.6a.657.657,0,0,0-.148-.325l-.03-.03c0-.03-.03-.03-.03-.059l-.118-.148a3.205,3.205,0,0,1-.237-.562.589.589,0,0,0-.237-.355l-.059-.03a.064.064,0,0,1-.059-.059.1.1,0,0,1-.03-.059.42.42,0,0,1-.059-.177l.089-.148c0-.059-.03-.118-.03-.177v-.089h.059l.089-.03a.4.4,0,0,0,.207-.385,1.79,1.79,0,0,0-.059-.444c0-.059-.03-.089-.03-.148a1.766,1.766,0,0,1,0-.562.742.742,0,0,1,.059-.3h0A1.99,1.99,0,0,0,13.724,31a1.293,1.293,0,0,0,.207-.237l.03-.059a.231.231,0,0,1,.118-.118,1.75,1.75,0,0,1,.592-.118h.207a2.3,2.3,0,0,1,.917.177c.059.03.089.03.148.059a.941.941,0,0,1,.444.385,1.013,1.013,0,0,1,.118.532,2.589,2.589,0,0,1-.059.473.819.819,0,0,0-.03.266v.089a.505.505,0,0,0,.03.355.529.529,0,0,0,.3.266v.089a.375.375,0,0,1-.03.177l-.03.118a.269.269,0,0,1-.089.207l-.03.089-.177.177a.842.842,0,0,0-.177.414c0,.03,0,.03-.03.059a1.363,1.363,0,0,1-.148.3c0,.03-.03.059-.059.089h-.03l-.089.148-.059.089v.059a.557.557,0,0,0-.059.237q-.222,1.2,1.242,1.6A2.793,2.793,0,0,1,18.87,38.1a1.34,1.34,0,0,1,.089.473v.532a.413.413,0,0,0,.089.266.321.321,0,0,0,.266.118h0a.373.373,0,0,0,.385-.385v-.118C19.7,38.6,19.7,38.544,19.7,38.544Z"
                              transform="translate(0 -20.07)"
                              fill="#383c40"
                            />
                            <path
                              id="Path_2761"
                              data-name="Path 2761"
                              d="M10.973,9.008a.467.467,0,0,1-.473-.473V3.359A2.168,2.168,0,0,1,12.659,1.2h.03c1.183.03,1.923,0,2.78,0h1.508a2.184,2.184,0,0,1,1.331.444,2.135,2.135,0,0,1,.858,1.627A4.13,4.13,0,0,1,18.9,5.1a3.371,3.371,0,0,1-.532.887A3.54,3.54,0,0,1,16.5,7.263a3.207,3.207,0,0,1-1.065.148H12.748L11.683,8.476l-.355.355A.416.416,0,0,1,10.973,9.008Zm1.686-7.069a1.444,1.444,0,0,0-1.449,1.42V7.973l1.035-1.035.03-.03a.584.584,0,0,1,.414-.177h2.751a3.849,3.849,0,0,0,.887-.118,3.017,3.017,0,0,0,1.479-1.035,2.622,2.622,0,0,0,.414-.739A4.216,4.216,0,0,0,18.427,3.3a1.346,1.346,0,0,0-.562-1.094,1.4,1.4,0,0,0-.887-.3H15.5c-.917.03-1.656.03-2.839.03Z"
                              transform="translate(-5.916)"
                              fill="#383c40"
                            />
                            <path
                              id="Path_2762"
                              data-name="Path 2762"
                              d="M41.568,3.511V8.6a.424.424,0,0,1-.148.325.445.445,0,0,1-.325.118.62.62,0,0,1-.325-.118l-.562-.562c-.3-.3-.562-.562-.769-.739H36.421a1.109,1.109,0,0,1-.325-.03l-.3-.03a5.069,5.069,0,0,0,.739-.651h2.928a.584.584,0,0,1,.414.177l.03.03.562.562.266.266.089.059v-4.5A1.3,1.3,0,0,0,39.5,2.21H37.279a2.04,2.04,0,0,0-.532-.71h2.78A2.035,2.035,0,0,1,41.568,3.511Z"
                              transform="translate(-23.732 -0.211)"
                              fill="#383c40"
                            />
                          </g>
                        </svg>
                      </v-list-item-icon>
                      <v-list-item-title>محادثة العميل</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
            <div
              class="req-status-parent mt-1 d-flex justify-space-between align-center"
            >
              <span class="req-type">{{ person.type || "غير محدد" }}</span>
              <span
                class="req-status"
                :style="`font-size: 13px;
                    padding: 0px 5px 5px;
                    color: white;${
                      person.status == `طلب تم فتحه`
                        ? `background-color:#40BE72`
                        : person.status == `طلب جديد`
                        ? `background-color:#3B5DE7`
                        : person.status == `مؤرشف لدى استشاري المبيعات`
                        ? `background-color:#017E84`
                        : person.status == `طلب مرفوض`
                        ? `background-color: indianred`
                        : person.status == `في انتظار موافقة مدير المبيعات`
                        ? `background-color: #FF715B`
                        : `background-color:black`
                    }`"
                >{{ person.status }}</span
              >
            </div>
            <div
              class="req-date-parent my-2 d-flex justify-space-between align-center"
            >
              <span class="req-date">{{
                person.agent_date.split(" ")[0]
              }}</span>
              <span
                class="req-status"
                :style="`font-size: 13px; color: #2158aa; font-weight: bold`"
                >{{ person.class_id_agent_text || "لايوجد تصنيف معاملة" }}</span
              >
            </div>
            <hr style="height: 1px !important; opacity: 0.3" class="mb-0" />
            <div class="desc parent">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-card-text v-on="on" class="pt-2 px-0">{{
                    person.agent_notes
                      ? person.agent_notes.length > 50
                        ? person.agent_notes.substring(0, 50) + "..."
                        : person.agent_notes
                      : "لايوجد ملاحظات"
                  }}</v-card-text>
                </template>
                <div>{{ person.agent_notes || "لايوجد ملاحظات" }}</div>
              </v-tooltip>
            </div>
          </v-card>
        </v-col>
        
      </v-row>
      <v-row class="mt-0 mx-0" v-if="currentRole == 1 && search_result.length">
        <v-col cols="12" lg="3" md="4" sm="6" xs="12" class="px-2 py-1"  v-for="person in search_result"
              :key="person.id * 100" >
            <RelatedAgentCardItem :item="person" :canopen="canOpenRequest" />
          </v-col>
        <!--  -->
      </v-row>
      <v-row class="mt-0 mx-0" v-if="currentRole == 5 && search_result.length">
        <v-col cols="12" lg="3" md="4" sm="6" xs="12" class="px-2 py-1"  v-for="person in search_result"
              :key="person.id * 100" >
            <QualityCardStyle :item="person" />
          </v-col>
        <!--  -->
      </v-row>
      <v-row v-if="!loading && search_result.length">
        <v-col cols="12" sm="2">
          <v-chip outlined color="danger" class="font-weight-bold my-0 py-0">
            الإجمالي : {{ getCount }}
          </v-chip>
        </v-col>
        <v-col cols="12" sm="9">
          <v-pagination
            v-model="page"
            :length="Math.ceil(getCount / 10) || 1"
            circle
          ></v-pagination>
        </v-col>
      </v-row>
      <div v-else class="d-flex justify-center align-center">
        <v-card elevation="0" width="100%">
          <v-card-title
            class="d-flex justify-center align-center font-weight-bold"
          >
            <h3>لا توجد نتائج للبحث</h3>
          </v-card-title>
        </v-card>
      </div>
    </template>
  </page-component>
</template>

<script>
import RelatedAgentCardItem from "./sales_manager/RelatedAgentCardItem.vue";
import QualityCardStyle from "./quality/CardStyle.vue";
export default {
  components:{RelatedAgentCardItem, QualityCardStyle},
  props: [],
  data() {
    return {
      canOpenRequest: 1,
      currentRole: 0,
      loading: false,
      customers: [],
      page: 1,
    };
  },
  computed: {
    search_result() {
      this.$store.state.search_result.data.forEach((person) => {
        this.$store.state.request_class.forEach((classId) => {
          if (classId.id == person.class_id_agent) {
            person.class_id_agent = classId.value;
          }
        });
      });
      return this.$store.state.search_result.data;
    },
    getCount() {
      return this.$store.state.search_result.searched;
    },
  },
  watch: {
    async page() {
      this.loading = true;
      await this.submit(this.page, true);
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
  },
  methods: {
    to_chat_page(item) {
      this.$router.push({
        name: "chat_component",
        query: {
          customer_name: item.customer.name,
          customer_id: item.customer.id,
          request_id: item.id,
        },
      });
    },
    select_element(item) {
      if (this.in_selected_elements(item)) {
        this.$store.state.elements = this.$store.state.elements.filter((el) => {
          return el.id != item.id;
        });
      } else {
        this.$store.state.elements.push(item);
      }
    },
    in_selected_elements(item) {
      return this.$store.state.elements.some((el) => {
        return el.id == item.id;
      });
    },
    deleteSelectedPerson(index) {
      this.$store.state.elements.splice(index, 1);
    },
    get_customers() {
      this.customers = [];
      this.$store.state.selected_customers.forEach((customer) => {
        this.customers.push(this.agent_customer(customer));
      });
    },
    to_request_details(item) {
      this.$router.push({ name: "request_details", params: { id: item.id } });
    },
    to_tickets_page(item) {
      this.$router.push({ name: "tickets", params: { id: item.id } });
    },
    submit(page = 1, isPaginated) {
      this.$root.$emit("SEARCHRESULT", page, isPaginated);
    },
    resetPage() {
      this.page = 1;
    },
  },
  async created() {
    await this.get_customers();
  },
  mounted() {
    if(localStorage["role"]){
      this.currentRole = localStorage["role"]
    }
    if(this.$route.name == "SMEAllRequests_" ||
        this.$route.name == "SMERecievedRequests" ||
        this.$route.name == "SMESpecialRequests" ||
        this.$route.name == "SMEFollowRequests" ||
        this.$route.name == "SMECompletedRequests" ||
        this.$route.name == "SMEArchievedRequests" ){
          this.canOpenRequest = 0
      }else{
        this.canOpenRequest = 1
      }
    this.page = 1;
    this.$root.$on("RESETPAGE", () => {
      this.resetPage();
    });
  },
};
</script>
<style lang="scss">
.selected-slider {
  .v-slide-group__content {
    align-items: center !important;
  }
  .theme--light.v-icon.v-icon:not(.mdi-close) {
    background-color: #f2f2f2 !important;
    border-color: #f2f2f2 !important;
    font-size: 40px;
    color: black;
  }
}
</style>
